import { createContext } from "react";

export type YearlyCycleContextType = {
    year: number;
    active: Set<number>;
};

export const YearlyCycleContext = createContext<YearlyCycleContextType | null>(null);
